export default "__VITE_ASSET__6fa1c015__"